(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5713],{

/***/ 7817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Navbar; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dynamic.js
var dynamic = __webpack_require__(6044);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/image.js
var next_image = __webpack_require__(1968);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var next_router = __webpack_require__(6971);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(5271);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-ellipsis-text@1.2.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-ellipsis-text/index.js
var react_ellipsis_text = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@5.7.0_react@18.3.1/node_modules/react-icons/io/index.mjs
var io = __webpack_require__(4869);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@5.7.0_react@18.3.1/node_modules/react-icons/rx/index.mjs
var rx = __webpack_require__(1273);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use-scroll-direction@0.1.0_react@18.3.1/node_modules/react-use-scroll-direction/dist/react-use-scroll-direction.esm.js
var react_use_scroll_direction_esm = __webpack_require__(6725);
// EXTERNAL MODULE: ./contexts/StoreDataContext.js + 1 modules
var StoreDataContext = __webpack_require__(3104);
// EXTERNAL MODULE: ./lib/cdn.js
var cdn = __webpack_require__(8071);
// EXTERNAL MODULE: ./lib/media.js
var media = __webpack_require__(1008);
// EXTERNAL MODULE: ./store/search-store.js
var search_store = __webpack_require__(7019);
// EXTERNAL MODULE: ./components/Picture.jsx
var Picture = __webpack_require__(473);
// EXTERNAL MODULE: ./components/utils/fileutil.js
var fileutil = __webpack_require__(9071);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9955);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(9363);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/Navbar/CartIconSvg.jsx


var _excluded = ["width", "height", "stroke", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var CartIconSvg = function CartIconSvg(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 22 : _ref$height,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 1 : _ref$stroke,
      color = _ref.color,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "-1 -1 22 24"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "a",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "0%",
          stopColor: "var(--color-primary)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "100%",
          stopColor: "var(--color-primary)"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: color || "var(--color-primary)",
        stroke: color || "var(--color-primary)",
        strokeWidth: stroke,
        fillRule: "nonzero",
        d: "M15.408 4.187h-.715a4.202 4.202 0 0 0-8.405 0h-.853a2.916 2.916 0 0 0-2.861 2.29L.07 17.64a2.93 2.93 0 0 0 2.861 3.573H17.91a2.932 2.932 0 0 0 2.861-3.573L18.269 6.477a2.915 2.915 0 0 0-2.862-2.29zM10.49.953a3.253 3.253 0 0 1 3.249 3.234H7.242A3.251 3.251 0 0 1 10.49.953zm8.964 18.564c-.374.47-.943.743-1.544.742H2.932a1.979 1.979 0 0 1-1.93-2.41L3.504 6.686a1.967 1.967 0 0 1 1.93-1.545h.853v2.294a.477.477 0 1 0 .954 0V5.141h6.499v2.294a.477.477 0 1 0 .954 0V5.141h.714a1.968 1.968 0 0 1 1.93 1.545L19.84 17.85c.133.586-.009 1.2-.386 1.668z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: 10.5,
        cy: 13.5,
        r: 2.5,
        fill: "url(#a)"
      })]
    })]
  }));
};

/* harmony default export */ var Navbar_CartIconSvg = (CartIconSvg);
;// CONCATENATED MODULE: ./components/Navbar/index.jsx


















var SearchSidebar = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(885), __webpack_require__.e(9062), __webpack_require__.e(4162), __webpack_require__.e(2868), __webpack_require__.e(1030), __webpack_require__.e(6763)]).then(__webpack_require__.bind(__webpack_require__, 1481));
}, {
  loading: function loading() {
    return null;
  },
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1481)];
    }
  }
});

var NavBar = function NavBar(props) {
  var _props$store$storeBan, _props$store, _props$store$storeBan2, _props$store2, _props$theme, _props$theme2, _props$store3, _props$theme3, _props$theme4;

  var context = (0,StoreDataContext/* useStoreContext */.Q)();
  var isProplanActive = context.isProplanActive;

  var _useState = (0,react.useState)(""),
      direction = _useState[0],
      setDirection = _useState[1];

  var _useScrollDirection = (0,react_use_scroll_direction_esm/* useScrollDirection */.C)(),
      isScrollingUp = _useScrollDirection.isScrollingUp,
      isScrollingDown = _useScrollDirection.isScrollingDown;

  var _useState2 = (0,react.useState)(false),
      isSideNavOpen = _useState2[0],
      setIsSideNavOpen = _useState2[1];

  var _useStore = (0,search_store/* default */.Z)(function (state) {
    return {
      isSearchOpen: state.isSearchOpen,
      setIsSearchOpen: state.setIsSearchOpen,
      shouldSearchReopen: state.shouldSearchReopen,
      setShouldSearchReopen: state.setShouldSearchReopen
    };
  }),
      isSearchOpen = _useStore.isSearchOpen,
      setIsSearchOpen = _useStore.setIsSearchOpen,
      shouldSearchReopen = _useStore.shouldSearchReopen,
      setShouldSearchReopen = _useStore.setShouldSearchReopen;

  var searchInputRef = (0,react.useRef)(null);
  var router = (0,next_router.useRouter)();
  var _props$homePage = props.homePage,
      homePage = _props$homePage === void 0 ? false : _props$homePage,
      _props$showSearch = props.showSearch,
      showSearch = _props$showSearch === void 0 ? true : _props$showSearch;
  (0,react.useEffect)(function () {
    if (shouldSearchReopen === router.asPath && !isSearchOpen) {
      setIsSearchOpen(true);
    } else {
      setIsSearchOpen(false);
    }
  }, [router.asPath, setIsSearchOpen, setShouldSearchReopen, shouldSearchReopen]);
  (0,react.useEffect)(function () {
    isScrollingDown && setDirection("down");
    isScrollingUp && setDirection("up");
  }, [isScrollingDown, isScrollingUp]);

  var checkoutShouldHide = function checkoutShouldHide() {
    if ( true && window.scrollY > 120) {
      return true;
    }

    return false;
  };

  var makeBGWhite = function makeBGWhite() {
    var shouldHide = false;

    if (true) {
      if (window.scrollY > 30) {
        shouldHide = true;
      }
    }

    return shouldHide;
  };

  var hasBanner = (_props$store$storeBan = (_props$store = props.store) === null || _props$store === void 0 ? void 0 : (_props$store$storeBan2 = _props$store.storeBanner) === null || _props$store$storeBan2 === void 0 ? void 0 : _props$store$storeBan2.text) !== null && _props$store$storeBan !== void 0 ? _props$store$storeBan : false;
  var isShopPage = router.pathname === "/shop";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("header", {
      className: homePage ? "z-50 flex h-[4.5rem] w-full items-center justify-between bg-background transition-all duration-300 ".concat(hasBanner ? isShopPage ? "sticky top-0" : "top-20" : "top-0", " ").concat(direction === "up" ? "opacity-100" : "", " ").concat(direction === "down" && checkoutShouldHide() ? "-top-16 opacity-0" : "") : "fixed left-1/2 top-0 z-[99] flex h-[72px] w-full max-w-[var(--max-width)] -translate-x-1/2 flex-row items-center justify-between bg-background opacity-100 transition-all duration-300 ease-in-out ".concat(direction === "up" ? "bg-background" : "", " ").concat(direction === "down" && checkoutShouldHide() ? "-top-[60px]" : "", " ").concat(direction === "down" && makeBGWhite() ? "bg-background" : "", " mb-5"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mx-auto flex h-[5rem] w-full max-w-[var(--max-width)] items-center justify-between px-6 py-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative z-10 flex w-full items-center justify-center",
          children: [isProplanActive && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: "absolute left-0 cursor-pointer text-primary",
            "aria-label": "Toggle side navigation menu",
            onClick: function onClick() {
              return props.toggleSideNav();
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(rx/* RxHamburgerMenu */.Bbf, {
              size: 28
            })
          }), isProplanActive && (_props$store2 = props.store) !== null && _props$store2 !== void 0 && _props$store2.logo && (0,media/* resolveImage */.rs)(props.store.logo, props.store.logoV2, "logo").isV2 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
            resolved: (0,media/* resolveImage */.rs)(props.store.logo, props.store.logoV2, "logo"),
            alt: "".concat(props.store.storeName, " Logo"),
            width: ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.logoShape) === "rectangle" ? 120 : 60,
            height: 60,
            loading: "eager",
            imgClassName: "object-contain ".concat(((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.logoShape) === "rectangle" ? "" : "rounded-full"),
            onClick: function onClick() {
              return router.push("/");
            }
          }) : isProplanActive && (_props$store3 = props.store) !== null && _props$store3 !== void 0 && _props$store3.logo ? /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            unoptimized: true,
            src: function () {
              var logo = props.store.logo;

              if (logo.includes("dm2buy")) {
                // eslint-disable-next-line no-undef
                var urlPath = logo ? new URL(logo).pathname : "";
                var extractedImageName = (0,fileutil/* parseFileName */.x)(urlPath).name;
                return "https://dm2buy-resize-dynamic-cebdcaefgydgh6hu.z02.azurefd.net/dm2buy/".concat(extractedImageName, ".jpg?quality=50");
              }

              return (0,cdn/* toCdnUrl */.V$)(logo);
            }(),
            alt: "".concat(props.store.storeName, " Logo"),
            width: ((_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.logoShape) === "rectangle" ? 120 : 60,
            height: 60,
            className: "object-contain ".concat(((_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.logoShape) === "rectangle" ? "" : "rounded-full"),
            layout: "fixed",
            onClick: function onClick() {
              return router.push("/");
            }
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "inline-block cursor-pointer text-center text-lg font-bold text-primary",
            onClick: function onClick() {
              return window.location.href = window.location.origin;
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_ellipsis_text["default"], {
              text: props.storeName,
              length: 25,
              tail: "..."
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "absolute right-0 z-10 flex gap-10",
            children: [isProplanActive && showSearch && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: "cursor-pointer text-primary",
              "aria-label": "Open search menu",
              onClick: function onClick() {
                setIsSearchOpen(!isSearchOpen);
                if (searchInputRef.current && !isSearchOpen) searchInputRef.current.focus();
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(io/* IoIosSearch */.FKI, {
                size: 26
              })
            }), props.cartActive && !props.hideInAdvance && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "mt-0.5",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: "mt-1.5 cursor-pointer text-primary",
                "aria-label": "Open cart",
                onClick: function onClick() {
                  return props.handleShowCart(true);
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_CartIconSvg, {
                  stroke: 0.5
                })
              })
            })]
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SearchSidebar, {
      isOpen: isSearchOpen,
      toggleDrawer: function toggleDrawer() {
        return setIsSearchOpen(!isSearchOpen);
      },
      store: props.store,
      searchRef: searchInputRef
    })]
  });
};

/* harmony default export */ var Navbar = (NavBar);

/***/ }),

/***/ 473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2676);

/**
 * <picture> with AVIF sources and a universal 512 WebP <img>, driven by a `resolveImage()` result.
 * On load error it steps through `resolved.fallbacks` (today's URL, then the raw legacy string)
 * instead of re-pinning straight to S3.
 *
 * Only rendered when `resolved.isV2` is true; components keep their existing markup otherwise, so
 * turning the flag off restores today's DOM exactly.
 */




var Picture = function Picture(_ref) {
  var _resolved$fallbacks, _resolved$sources;

  var resolved = _ref.resolved,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "" : _ref$alt,
      className = _ref.className,
      imgClassName = _ref.imgClassName,
      style = _ref.style,
      width = _ref.width,
      height = _ref.height,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? "lazy" : _ref$loading,
      fetchpriority = _ref.fetchpriority,
      _ref$decoding = _ref.decoding,
      decoding = _ref$decoding === void 0 ? "async" : _ref$decoding,
      onLoad = _ref.onLoad,
      onClick = _ref.onClick,
      draggable = _ref.draggable;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1),
      step = _useState[0],
      setStep = _useState[1]; // -1 = primary, 0.. = fallbacks


  var srcRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(resolved === null || resolved === void 0 ? void 0 : resolved.src);
  var imgRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null); // Reset the fallback chain *during* render, not in an effect: carousel slides (key={index}) and
  // list items reuse this instance for a different image, and a post-render reset would leave the
  // first render on the previous image's fallback — or on `undefined` when the new chain is
  // shorter. React re-renders with the new state before committing this one.

  var current = step;

  if (srcRef.current !== (resolved === null || resolved === void 0 ? void 0 : resolved.src)) {
    srcRef.current = resolved === null || resolved === void 0 ? void 0 : resolved.src;
    current = -1;
    if (step !== -1) setStep(-1);
  }

  var stepRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(current);
  stepRef.current = current;
  var hasImage = !!(resolved && resolved.src);
  var usingFallback = current >= 0;
  var src = !hasImage ? undefined : usingFallback ? (_resolved$fallbacks = resolved.fallbacks) === null || _resolved$fallbacks === void 0 ? void 0 : _resolved$fallbacks[current] : resolved.src; // An error that fired before React attached onError (e.g. carousel clones, hydration) is
  // otherwise lost: a complete image with no pixels means the primary candidate failed. This can
  // only happen for the candidate the element mounts with — once React has attached onError, that
  // handler owns every later failure — so it runs once per image, on the primary only. Without
  // that bound (and without a dependency array) it re-fired on every ancestor render and burned
  // the whole chain on any zero-pixel image that had not actually errored.

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!src || stepRef.current !== -1) return;
    var el = imgRef.current;

    if (el && el.complete && el.naturalWidth === 0 && ((resolved === null || resolved === void 0 ? void 0 : resolved.fallbacks) || []).length > stepRef.current + 1) {
      setStep(stepRef.current + 1);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [src]);
  if (!hasImage) return null;

  var onError = function onError() {
    var next = stepRef.current + 1;
    if (next < (resolved.fallbacks || []).length) setStep(next);
  };

  var img = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
    ref: imgRef,
    src: src,
    alt: alt,
    className: imgClassName || className,
    style: style,
    width: width || resolved.width,
    height: height || resolved.height,
    sizes: !usingFallback ? resolved.sizes : undefined,
    loading: loading,
    decoding: decoding // React 18 warns on camelCase for this attribute; lowercase reaches the DOM as-is.
    ,
    fetchpriority: fetchpriority,
    onLoad: onLoad,
    onError: onError,
    onClick: onClick,
    draggable: draggable
  }); // Once we are on a fallback, drop the AVIF sources too: the browser would otherwise keep
  // choosing a <source> and never use the fallback <img src>.


  if (usingFallback || !((_resolved$sources = resolved.sources) !== null && _resolved$sources !== void 0 && _resolved$sources.length)) return img;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("picture", {
    className: imgClassName ? className : undefined,
    children: [resolved.sources.map(function (s) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
        type: s.type,
        srcSet: s.srcSet,
        sizes: s.sizes
      }, s.type);
    }), img]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Picture);

/***/ }),

/***/ 2130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SideNavDrawer; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var next_router = __webpack_require__(6971);
// EXTERNAL MODULE: ./contexts/StoreDataContext.js + 1 modules
var StoreDataContext = __webpack_require__(3104);
// EXTERNAL MODULE: ./hooks/useCollection.js
var useCollection = __webpack_require__(7191);
// EXTERNAL MODULE: ./node_modules/.pnpm/tailwind-merge@3.6.0/node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(3358);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/Carousel/ArrowSvg.jsx



var ArrowSvg = function ArrowSvg(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    className: (0,bundle_mjs/* twMerge */.m6)("icon icon-arrow icon--medium ".concat(className)),
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7.5 3.74121L13.75 9.99121L7.5 16.2412",
      stroke: color,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

/* harmony default export */ var Carousel_ArrowSvg = (ArrowSvg);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/link.js
var next_link = __webpack_require__(317);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/LinkItem.jsx




var LinkItem = function LinkItem(_ref) {
  var href = _ref.href,
      label = _ref.label,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: href,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: (0,bundle_mjs/* twMerge */.m6)("m-0 opacity-100", className),
      children: label
    })
  });
};

/* harmony default export */ var components_LinkItem = (LinkItem);
;// CONCATENATED MODULE: ./components/SideNavDrawer.jsx








var SideNavDrawer = function SideNavDrawer(_ref) {
  var isOpen = _ref.isOpen,
      toggleDrawer = _ref.toggleDrawer;
  var context = (0,StoreDataContext/* useStoreContext */.Q)();
  var store = context === null || context === void 0 ? void 0 : context.storeData;
  var router = (0,next_router.useRouter)();

  var _useCollection = (0,useCollection/* default */.ZP)(store === null || store === void 0 ? void 0 : store.id, ""),
      collectionsData = _useCollection.data,
      isCollectionsLoading = _useCollection.isLoading,
      collectionsError = _useCollection.error;

  var collections = collectionsData ? collectionsData.collections : [];
  if (collectionsError) return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: "Error loading collections"
  });

  var onClickItem = function onClickItem(path) {
    router.push(path);
    toggleDrawer();
  };

  if (collectionsError) return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: "Error loading collections"
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("aside", {
    className: "fixed left-0 top-0 z-[101] h-screen w-screen transform overflow-y-auto bg-background text-fontBackground shadow-lg transition-transform ".concat(isOpen ? "translate-x-0" : "-translate-x-full"),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex items-center p-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-lg font-bold",
        children: store === null || store === void 0 ? void 0 : store.storeName
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "absolute right-5 top-10 z-50 inline-block w-[22px] border-0 bg-transparent",
        onClick: toggleDrawer,
        "aria-label": "Close drawer",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative h-[15px] w-full rotate-0 transform cursor-pointer transition duration-500 ease-in-out ".concat(isOpen ? "open" : ""),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "duration-250 absolute left-0 top-[7px] block h-[2px] w-full transform rounded-lg bg-primary opacity-100 transition ease-in-out ".concat(isOpen ? "rotate-45" : "rotate-0")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "duration-250 absolute left-0 top-[7px] block h-[2px] w-full transform rounded-lg bg-primary opacity-100 transition ease-in-out ".concat(isOpen ? "-rotate-45" : "rotate-0")
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
      className: "mt-3",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: "space-y-0 text-lg",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          onClick: function onClick() {
            return toggleDrawer();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_LinkItem, {
            href: "/",
            label: "Home",
            className: "block px-4 py-2 hover:opacity-80"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          onClick: function onClick() {
            return toggleDrawer();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_LinkItem, {
            href: "/shop",
            label: "Shop",
            className: "block px-4 py-2 hover:opacity-80"
          })
        }), isCollectionsLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {}) : collections.length > 0 && collections.map(function (collection) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              className: "flex cursor-pointer items-center justify-between px-4 py-2 hover:opacity-80",
              onClick: function onClick() {
                return onClickItem("/shop?collection=".concat(collection.name));
              },
              children: [collection.name, /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel_ArrowSvg, {
                className: "h-5 w-5",
                color: "var(--font-background)"
              })]
            })
          }, collection._id);
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          onClick: function onClick() {
            return toggleDrawer();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_LinkItem, {
            href: "/contact",
            label: "Contact us",
            className: "mb-4 block px-4 py-2 hover:opacity-80"
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var components_SideNavDrawer = (SideNavDrawer);

/***/ }),

/***/ 9071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ parseFileName; }
/* harmony export */ });
var parseFileName = function parseFileName(url) {
  if (!url) return "";
  var parts = url.split("/");
  var filename = parts[parts.length - 1].split("?")[0];
  return {
    name: filename.substring(0, filename.lastIndexOf(".")),
    ext: filename.substring(filename.lastIndexOf("."))
  };
};

/***/ }),

/***/ 7191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ow": function() { return /* binding */ useCollectionsWithProducts; }
/* harmony export */ });
/* unused harmony export usePaginatedCollections */
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2186);
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7039);
/* harmony import */ var _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3805);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6587);
/* harmony import */ var _services_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3236);





var fetchCollections = /*#__PURE__*/function () {
  var _ref = (0,_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(storeId) {
    var source,
        response,
        _args = arguments;
    return _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            source = _args.length > 1 && _args[1] !== undefined ? _args[1] : "featured";
            _context.next = 3;
            return fetch("".concat((0,_services_helper__WEBPACK_IMPORTED_MODULE_1__/* .getPublicServerEndpoint */ .rq)(), "/v3/collection/store/").concat(storeId).concat(source ? "?source=".concat(source) : ""));

          case 3:
            response = _context.sent;

            if (response.ok) {
              _context.next = 6;
              break;
            }

            throw new Error("Failed to fetch collections");

          case 6:
            return _context.abrupt("return", response.json());

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchCollections(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchCollectionsPage = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var storeId, _ref2$pageParam, pageParam, _ref2$limit, limit, response;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            storeId = _ref2.storeId, _ref2$pageParam = _ref2.pageParam, pageParam = _ref2$pageParam === void 0 ? 1 : _ref2$pageParam, _ref2$limit = _ref2.limit, limit = _ref2$limit === void 0 ? 5 : _ref2$limit;
            _context2.prev = 1;
            _context2.next = 4;
            return fetch("".concat(getPublicServerEndpoint(), "/v3/collection/store/").concat(storeId, "?limit=").concat(limit, "&page=").concat(pageParam));

          case 4:
            response = _context2.sent;

            if (response.ok) {
              _context2.next = 7;
              break;
            }

            throw new Error("Failed to fetch collections: ".concat(response.status, " ").concat(response.statusText));

          case 7:
            return _context2.abrupt("return", response.json());

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            console.error("Error fetching collections page ".concat(pageParam, ":"), _context2.t0);
            throw _context2.t0;

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 10]]);
  }));

  return function fetchCollectionsPage(_x2) {
    return _ref3.apply(this, arguments);
  };
}()));

var useCollection = function useCollection(storeId) {
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "featured";
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)(["collections", storeId, source], function () {
    return fetchCollections(storeId, source);
  }, {
    enabled: !!storeId
  });
};
/**
 * Hook for fetching collections with pagination
 * @param {string} storeId - Store ID to fetch collections for
 * @param {number} limit - Number of collections per page
 * @returns {Object} - React Query infinite query result
 */


var usePaginatedCollections = function usePaginatedCollections(storeId) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  return useInfiniteQuery(["paginatedCollections", storeId, limit], function (_ref4) {
    var _ref4$pageParam = _ref4.pageParam,
        pageParam = _ref4$pageParam === void 0 ? 1 : _ref4$pageParam;
    return fetchCollectionsPage({
      storeId: storeId,
      pageParam: pageParam,
      limit: limit
    });
  }, {
    enabled: !!storeId,
    getNextPageParam: function getNextPageParam(lastPage, allPages) {
      // Use the pagination.pages from the response to determine if there are more pages
      if (!lastPage.pagination || !lastPage.pagination.pages) {
        return undefined; // No pagination info available
      }

      var currentPage = allPages.length;
      var totalPages = lastPage.pagination.pages; // Return undefined if we're at the last page to prevent extra API calls

      return currentPage < totalPages ? currentPage + 1 : undefined;
    }
  });
};

var fetchCollectionsWithProducts = /*#__PURE__*/function () {
  var _ref6 = (0,_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(_ref5) {
    var storeId, _ref5$pageParam, pageParam, _ref5$limit, limit, _ref5$productsPerColl, productsPerCollection, response;

    return _vercel_path0_node_modules_pnpm_next_12_3_7_babel_core_7_29_7_react_dom_18_3_1_react_18_3_1_react_18_3_1_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            storeId = _ref5.storeId, _ref5$pageParam = _ref5.pageParam, pageParam = _ref5$pageParam === void 0 ? 1 : _ref5$pageParam, _ref5$limit = _ref5.limit, limit = _ref5$limit === void 0 ? 5 : _ref5$limit, _ref5$productsPerColl = _ref5.productsPerCollection, productsPerCollection = _ref5$productsPerColl === void 0 ? 10 : _ref5$productsPerColl;
            _context3.prev = 1;
            _context3.next = 4;
            return fetch("".concat((0,_services_helper__WEBPACK_IMPORTED_MODULE_1__/* .getPublicServerEndpoint */ .rq)(), "/v4/collection/store/").concat(storeId, "/with-products?page=").concat(pageParam, "&limit=").concat(limit, "&productsPerCollection=").concat(productsPerCollection));

          case 4:
            response = _context3.sent;

            if (response.ok) {
              _context3.next = 7;
              break;
            }

            throw new Error("Failed to fetch collections with products: ".concat(response.status, " ").concat(response.statusText));

          case 7:
            return _context3.abrupt("return", response.json());

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](1);
            console.error("Error fetching collections with products page ".concat(pageParam, ":"), _context3.t0);
            throw _context3.t0;

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 10]]);
  }));

  return function fetchCollectionsWithProducts(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * Hook for fetching collections with products in a single API call
 * @param {string} storeId - Store ID to fetch collections for
 * @param {number} limit - Number of collections per page
 * @param {number} productsPerCollection - Number of products per collection
 * @returns {Object} - React Query infinite query result
 */


var useCollectionsWithProducts = function useCollectionsWithProducts(storeId) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  var productsPerCollection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useInfiniteQuery */ .N)(["collectionsWithProducts", storeId, limit, productsPerCollection], function (_ref7) {
    var _ref7$pageParam = _ref7.pageParam,
        pageParam = _ref7$pageParam === void 0 ? 1 : _ref7$pageParam;
    return fetchCollectionsWithProducts({
      storeId: storeId,
      pageParam: pageParam,
      limit: limit,
      productsPerCollection: productsPerCollection
    });
  }, {
    enabled: !!storeId,
    getNextPageParam: function getNextPageParam(lastPage, allPages) {
      if (!lastPage.pagination || !lastPage.pagination.pages) {
        return undefined;
      }

      var currentPage = allPages.length;
      var totalPages = lastPage.pagination.pages;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    }
  });
};


/* harmony default export */ __webpack_exports__["ZP"] = (useCollection);

/***/ }),

/***/ 8071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V$": function() { return /* binding */ toCdnUrl; },
/* harmony export */   "b0": function() { return /* binding */ getCdnHost; }
/* harmony export */ });
/* unused harmony exports isS3MetaUrl, isMediaBucketUrl */
/* provided dependency */ var process = __webpack_require__(9933);
/* global process, URL */
var S3_META_HOST = "shop-meta.s3.ap-south-1.amazonaws.com"; // New media bucket (dayzero account). Old-field URLs from new uploads point here (img/<id>/v1/512.webp).

var MEDIA_BUCKET_HOST = (process.env.NEXT_PUBLIC_MEDIA_BUCKET_HOST || "sh0p-media.s3.ap-south-1.amazonaws.com").replace(/^https?:\/\//, "").replace(/\/$/, "");

var isCdnEnabled = function isCdnEnabled() {
  return "true" === "true";
};

var getCdnHost = function getCdnHost() {
  return ("d2iai535y0ceb2.cloudfront.net" || 0).replace(/^https?:\/\//, "").replace(/\/$/, "");
};
var isS3MetaUrl = function isS3MetaUrl(url) {
  if (!url) return false;

  try {
    var _URL = new URL(url),
        hostname = _URL.hostname;

    return hostname === S3_META_HOST || hostname.includes("shop-meta.s3");
  } catch (_unused) {
    return typeof url === "string" && url.includes("shop-meta.s3");
  }
};
/** URLs on the new media bucket are also served by the same CloudFront distribution (/img/*, /raw/*). */

var isMediaBucketUrl = function isMediaBucketUrl(url) {
  if (!url) return false;

  try {
    return new URL(url).hostname === MEDIA_BUCKET_HOST;
  } catch (_unused2) {
    return typeof url === "string" && url.includes(MEDIA_BUCKET_HOST);
  }
};
/** Rewrite shop-meta / media-bucket S3 URLs to CloudFront when the flag is on. Azure and other hosts are unchanged. */

var toCdnUrl = function toCdnUrl(url) {
  if (!url || !isCdnEnabled()) return url;
  var cdnHost = getCdnHost();
  if (!cdnHost || !(isS3MetaUrl(url) || isMediaBucketUrl(url))) return url;

  try {
    var parsed = new URL(url);
    parsed.protocol = "https:";
    parsed.host = cdnHost;
    return parsed.toString();
  } catch (_unused3) {
    return url;
  }
};

/***/ }),

/***/ 1008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qf": function() { return /* binding */ ogImage; },
/* harmony export */   "rs": function() { return /* binding */ resolveImage; }
/* harmony export */ });
/* unused harmony exports isMediaV2Enabled, SLOTS, isAzureLegacy, legacyUrl */
/* harmony import */ var _cdn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8071);
/* global process, URL */

/**
 * Image resolver for the media pipeline (see s3-costing/IMAGE_MIGRATION_PLAN.md §2.6).
 *
 * Every entity that has an image field also has a `*V2` field with entries
 *   { src, key, w, h, status, url? }
 * joined to the legacy URL by `src`. When an entry is `ready` and the flag is on, we render
 * pre-generated variants from CloudFront:
 *   <CDN>/<key>/256.avif  <CDN>/<key>/512.avif  <CDN>/<key>/512.webp  <CDN>/<key>/orig.avif
 * Otherwise we return today's URL (Azure resize URL for legacy Azure images, CloudFront via
 * toCdnUrl for S3 images), so a missing/pending entry changes nothing.
 */

var isMediaV2Enabled = function isMediaV2Enabled() {
  return "true" === "true";
};

var cdnBase = function cdnBase() {
  var host = (0,_cdn__WEBPACK_IMPORTED_MODULE_0__/* .getCdnHost */ .b0)();
  return host ? "https://".concat(host) : "";
};
/**
 * Per-slot candidate lists. Browsers pick a candidate by CSS size × device pixel ratio, so the
 * grid never offers `orig` (a 3× phone would otherwise fetch the full image for a thumbnail).
 */


var SLOTS = {
  // Product tile and featured-collection card share a box: `calc(50vw - 33px)` under the 768px
  // breakpoint, then a fixed `calc(520px/2 - 33px)` = 227px once the 520px container caps out.
  // Declaring the real box (not a viewport fraction) is what keeps the pick stable: 512 for every
  // DPR above 1, and 256 only on a genuinely low-DPR screen, where 256 physical px already covers
  // the box. A viewport fraction made the choice track window width on desktop even though the
  // tile never changes size.
  grid: {
    sizes: "(max-width: 768px) calc(50vw - 33px), 227px",
    avif: [512, 256]
  },
  // Collection-home / similar-products tile: `var(--max-width)/1.5 - 50px` = 297px at every width.
  gridWide: {
    sizes: "297px",
    avif: [512, 256]
  },
  pdp: {
    sizes: "(max-width: 768px) 100vw, 480px",
    avif: [512, "orig"]
  },
  cart: {
    sizes: "96px",
    avif: [256]
  },
  logo: {
    sizes: "120px",
    avif: [256]
  },
  hero: {
    sizes: "100vw",
    avif: [512, "orig"]
  },
  sidebar: {
    sizes: "70px",
    avif: [256]
  },
  collection: {
    sizes: "(max-width: 768px) calc(50vw - 33px), 227px",
    avif: [512, 256]
  },
  review: {
    sizes: "250px",
    avif: [512]
  }
};
/** Legacy Azure hosts the storefront still rewrites (unchanged behaviour). */

var AZURE_RESIZE = "https://dm2buy-resize-dynamic-cebdcaefgydgh6hu.z02.azurefd.net/dm2buy/";
var AZURE_DROP = "https://dm2buy-drop-resized-gga4c6azekgcgngp.z02.azurefd.net/dm2buy/";
/** Today's guard, made safe for the new bucket: an S3 URL is never an Azure URL. */

var isAzureLegacy = function isAzureLegacy(url) {
  return typeof url === "string" && url.includes("dm2buy") && !url.includes("amazonaws.com");
};

var fileName = function fileName(url) {
  try {
    return new URL(url).pathname.split("/").pop().split("?")[0];
  } catch (_unused) {
    return String(url || "").split("/").pop().split("?")[0];
  }
};

var baseName = function baseName(url) {
  var f = fileName(url);
  var i = f.lastIndexOf(".");
  return i > 0 ? f.substring(0, i) : f;
};
/**
 * Exactly what each component renders today for a legacy URL, by slot.
 */


function legacyUrl(src) {
  var slot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "grid";
  if (!src) return src;

  if (isAzureLegacy(src)) {
    switch (slot) {
      case "grid":
      case "gridWide":
        return "".concat(AZURE_RESIZE).concat(baseName(src), ".jpg?width=400&height=400");

      case "pdp":
        return "".concat(AZURE_DROP).concat(fileName(src));

      case "cart":
      case "logo":
        return "".concat(AZURE_RESIZE).concat(baseName(src), ".jpg?quality=50");

      case "hero":
        return "".concat(AZURE_RESIZE).concat(fileName(src), "?width=500&quality=80");

      default:
        return src;
    }
  }

  return (0,_cdn__WEBPACK_IMPORTED_MODULE_0__/* .toCdnUrl */ .V$)(src);
}

var findV2 = function findV2(src, v2) {
  if (!src || !v2) return null;
  if (Array.isArray(v2)) return v2.find(function (m) {
    return m && m.src === src && m.status === "ready" && m.key;
  });
  return v2.src === src && v2.status === "ready" && v2.key ? v2 : null;
};
/**
 * `w`/`h` are optional in the backend schema, so a `ready` entry can arrive without them. Every
 * width descriptor would then be `0w`, which invalidates the whole AVIF srcSet (the browser drops
 * the candidates and skips the <source>) and leaves width/height unset, losing the layout-shift
 * reservation. Such an entry is not usable as V2: fall back to today's URL instead.
 */


var hasDimensions = function hasDimensions(entry) {
  return Number.isFinite(entry === null || entry === void 0 ? void 0 : entry.w) && entry.w > 0 && Number.isFinite(entry === null || entry === void 0 ? void 0 : entry.h) && entry.h > 0;
};
/**
 * Resolve one image for a slot.
 * @param {string} src            the legacy URL (value of productPhotos[i], store.logo, ...)
 * @param {Array|Object} v2       the matching *V2 field (array for lists, object for singles)
 * @param {keyof SLOTS} slot
 * @returns {{ isV2: boolean, src: string, fallbacks: string[], sources?: Array, width?: number, height?: number, sizes?: string }}
 *   `src` is what goes in <img src>; `fallbacks` are tried in order by the onError handler.
 */


function resolveImage(src, v2) {
  var slot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "grid";
  var cfg = SLOTS[slot] || SLOTS.grid;
  var entry = isMediaV2Enabled() ? findV2(src, v2) : null;
  var base = cdnBase();

  if (entry && base && hasDimensions(entry)) {
    var u = function u(name) {
      return "".concat(base, "/").concat(entry.key, "/").concat(name);
    };

    var w = entry.w;
    var h = entry.h;
    var L = Math.max(w, h); // width descriptor = the variant's real width (256/512 are long-edge caps; portrait 1080×1440 → 384w)

    var widthOf = function widthOf(t) {
      return t === "orig" ? w : Math.round(Math.min(t, L) * w / L);
    };

    return {
      isV2: true,
      src: u("512.webp"),
      width: w,
      height: h,
      sizes: cfg.sizes,
      sources: [{
        type: "image/avif",
        srcSet: cfg.avif.map(function (t) {
          return "".concat(u("".concat(t, ".avif")), " ").concat(widthOf(t), "w");
        }).join(", "),
        sizes: cfg.sizes
      }],
      // if the CDN variant fails (or the browser decodes neither AVIF nor WebP), fall back to
      // today's URL, then the raw stored string: both are the original image for every source
      fallbacks: [legacyUrl(src, slot), src].filter(function (x, i, arr) {
        return x && x !== u("512.webp") && arr.indexOf(x) === i;
      })
    };
  }

  var legacy = legacyUrl(src, slot);
  return {
    isV2: false,
    src: legacy,
    fallbacks: legacy !== src ? [src] : []
  };
}
/**
 * og:image for link previews. Crawlers do not negotiate AVIF; 512.webp is accepted by Meta and
 * WhatsApp. Falls back to today's CDN URL of the original.
 */

function ogImage(src, v2) {
  if (!src) return src;
  var entry = isMediaV2Enabled() ? findV2(src, v2) : null;
  var base = cdnBase();
  if (entry && base) return "".concat(base, "/").concat(entry.key, "/512.webp");
  if (src.startsWith("//")) return "https:".concat(src);
  return (0,_cdn__WEBPACK_IMPORTED_MODULE_0__/* .toCdnUrl */ .V$)(src);
}

/***/ }),

/***/ 7019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5005);
// stores/useStore.js

var useStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function (set) {
  return {
    data: null,
    scrollPosition: 0,
    setScrollPosition: function setScrollPosition(position) {
      return set({
        scrollPosition: position
      });
    },
    setData: function setData(data) {
      return set({
        data: data
      });
    },
    searchQuery: "",
    lastTrackedQuery: "",
    setSearchQuery: function setSearchQuery(query) {
      return set({
        searchQuery: query,
        scrollPosition: 0
      });
    },
    isSearchOpen: false,
    setIsSearchOpen: function setIsSearchOpen(isSearchOpen) {
      set({
        isSearchOpen: isSearchOpen
      });
    },
    shouldSearchReopen: false,
    setShouldSearchReopen: function setShouldSearchReopen(shouldSearchReopen) {
      set({
        shouldSearchReopen: shouldSearchReopen
      });
    },
    setLastTrackedQuery: function setLastTrackedQuery(query) {
      return set({
        lastTrackedQuery: query
      });
    }
  };
});
/* harmony default export */ __webpack_exports__["Z"] = (useStore);

/***/ }),

/***/ 7623:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__bCOhY","cart":"Home_cart__LyzTg","about":"Home_about__6Y_1_","profilePic":"Home_profilePic__7nemD","footerTagline":"Home_footerTagline__wH1if","notFound":"Home_notFound___6xAl","notFoundMessage":"Home_notFoundMessage__KeTwU","notFoundHeadHome":"Home_notFoundHeadHome__0_jo1","link":"Home_link__mt0ji","title404":"Home_title404__7ZWAE"};

/***/ })

}]);